import React from 'react';
import PropTypes from 'prop-types';
import { GoogleMap, Marker, withGoogleMap, withScriptjs, InfoWindow} from "react-google-maps"
import { connect } from 'react-redux';
import { updateSelectedMapItem, setVolunteerRequest } from '../../actions/volunteerActions';
import { randomBytes } from 'crypto';
import {colors} from './../../assets/theme';
class HitMapMarker extends React.Component {   

    constructor(props){
        super(props);
        this.state = {
            open : false
        }
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){

        const renderRequests = ()=>{
            if(!this.props.mapSelection || !this.props.mapSelection.requests) return null;

            return this.props.mapSelection.requests.map((request, idx)=>{
                return (
                    <p key={idx} className="request" onClick={()=>{this.props.setVolunteerRequest(this.props.hit, request.requestId)}} >
                        <style jsx>{`
                        .request {
                            font-size:15px;
                            border-bottom:1px solid ${colors.primary};
                            color :${colors.primary};
                            margin-bottom:5px;
                        }
                        `}</style>
                        {request.title}
                    </p>
                )
            })
        }
        
        let {lat, lng} = this.props.hit._rankingInfo.matchedGeoLocation;
        return (

            
            <Marker onClick={()=>{this.props.updateSelectedMapItem(this.props.hit)}} position={{lat: lat, lng:lng }}>
            {
                
                (this.props.mapSelection.objectID==this.props.hit.objectID) ? <InfoWindow onCloseClick={()=>{this.props.updateSelectedMapItem(null)}}>
                
                
                <div className="root">    
                    <style jsx>{`
                        .root {
                            color: red;
                        }
                        .title {
                            font-size:15px;
                            color: ${colors.primary};
                            font-weight:700
                        }
                        .logo {
                            width: 20px;
                            height: 20px;
                            float: left;
                            margin-right:5px;
                            background-size: contain;
                            background-position: center;
                            display: block;
                        }
                        
                    `}</style>
                    <p className="title">
                    <span className="logo" style={{backgroundImage : `url(${this.props.hit.image})`}}  />
                    {this.props.hit.name}</p>
                    {/* <p className="HitMapMarker-decscription m-0">{this.props.hit.description}</p> */}
                    {renderRequests()}
                    {/* <a className="bold f5 c-primary" onClick={()=>{this.props.setInventoryItem(this.props.hit)}} >More</a> */}
                </div>
                </InfoWindow> : null
            }
            </Marker>
        )
    }
}

HitMapMarker.propTypes = {
    
}


const mapStateProps = (state) => {
    return {
        mapSelection : state.volunteer.mapSelection
    };
}

export default  connect(mapStateProps, {updateSelectedMapItem, setVolunteerRequest})(HitMapMarker);



// WEBPACK FOOTER //
// ./src/components/common/VolunteerHitMapMarker.js